<app-dialog-base class="modalobjectgallery" [Title]='"Object files"|translate' [dialogId]="dialogId" (onClose)="close()" [height]="'550px'" [width]="'850px'" [ExitButton]="true">

  <div class="navblock">
    <div></div>
    <input type="text" class="dtpickerupleft" value="" />
    <button class="btn_blue">{{'Apply'|translate }}</button>
  </div>

  <div class="horseparator"></div>

  <div class="photos-group">
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
    <div class="photo-container">
      <div class="photo-wrapper" onclick="openModal('objectPhotoModal')">
        <div class="photo"></div>
      </div>
      <span class="photo-info"> 04.04.18 15:23</span>
    </div>
  </div>
</app-dialog-base>
